var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockedCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.375H13.25V4.875C13.25 2.805 11.57 1.125 9.5 1.125C7.43 1.125 5.75 2.805 5.75 4.875V6.375H5C4.175 6.375 3.5 7.05 3.5 7.875V15.375C3.5 16.2 4.175 16.875 5 16.875H14C14.825 16.875 15.5 16.2 15.5 15.375V7.875C15.5 7.05 14.825 6.375 14 6.375ZM7.25 4.875C7.25 3.63 8.255 2.625 9.5 2.625C10.745 2.625 11.75 3.63 11.75 4.875V6.375H7.25V4.875ZM14 15.375H5V7.875H14V15.375ZM9.5 13.125C10.325 13.125 11 12.45 11 11.625C11 10.8 10.325 10.125 9.5 10.125C8.675 10.125 8 10.8 8 11.625C8 12.45 8.675 13.125 9.5 13.125Z",
    fill: "#3B0002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedCard);
export default __webpack_public_path__ + "static/media/blockedCard.9077c928354f63902463f4b4bfdd22a9.svg";
export { ForwardRef as ReactComponent };